<template>
    <div class="aa-NoResults font-semibold leading-snug text-center text-gray-500 break-words px-4 py-16">
        {{ text }} “{{ state.query }}”
    </div>
</template>

<script setup>
defineProps({
    state: {
        type: Object,
        default() {},
    },
    text: {
        type: String,
        required: true,
    },
});
</script>
